export default __webpack_public_path__ + "static/media/expertise.09e676f0.svg";